import { render } from "./ToolUsersModal.vue?vue&type=template&id=b45bbc64"
import script from "./ToolUsersModal.vue?vue&type=script&lang=js"
export * from "./ToolUsersModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__